import React from 'react';
import { Link, } from 'react-router-dom'

const Pagination = (totalPages, pageNumber) => {
  let pageItems = [];
  let page = parseInt(pageNumber);
  let total = parseInt(totalPages)+1;
  let i = page - 2
  if (i < page + 5 ){
    for (i ; i < page+5 ; i++) {
      if (i > 0 && i < total) {
        pageItems.push(<li key={i} className="page-item"><p><Link to={`${i}`} className="page-link"  >{i}</Link></p></li>);
      }
  }
}
  const linkToBackPage = page > 0 ?
    <Link className="page-link" to={`${page-1}`} aria-label="Previous">
      <span aria-hidden="true">&lsaquo;</span>
      <span className="sr-only">Previous</span>
    </Link> :
    <Link className="page-link" to={`${page}`} aria-label="Previous">
      <span aria-hidden="true">&lsaquo;</span>
      <span className="sr-only">Previous</span>
    </Link>

  const linkToForwardPage = page < total ?
    <Link className="page-link" to={`${page+1}`} aria-label="Next">
      <span aria-hidden="true">&rsaquo;</span>
      <span className="sr-only">Next</span>
    </Link> :
    <Link className="page-link" to={`${page}`} aria-label="Next">
      <span aria-hidden="true">&rsaquo;</span>
      <span className="sr-only">Next</span>
    </Link>


  return (
    <nav aria-label="center">
      <ul className="pagination justify-content-center">
        <li className="page-item">
          <Link className="page-link" to={`${0}`} aria-label="Next">
            <span aria-hidden="true">&laquo;</span>
            <span className="sr-only">Next</span>
          </Link>
        </li>
        <li className="page-item">

          {linkToBackPage}
        </li>
        {pageItems}
        <li className="page-item">
          {linkToForwardPage}
        </li>
        <li className="page-item">
        <Link className="page-link" to={`${totalPages}`} aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
          <span className="sr-only">Next</span>
        </Link>
        </li>
      </ul>
    </nav>
  );
};
export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.js